import { isNotDefined, isObject } from '@hsp/utilities';

export const dateTransformer = (data: unknown): unknown => {
  if (isNotDefined(data)) {
    return;
  }

  if (data instanceof FormData) {
    return data;
  }

  if (data instanceof Date) {
    return data.toLocaleString();
  }

  if (Array.isArray(data)) {
    return data.map(dateTransformer);
  }

  if (isObject(data)) {
    return Object.fromEntries(Object.entries(data).map(([key, value]) => [key, dateTransformer(value)]));
  }

  return data;
};
